// 他参加者のカーソル位置を表示するレイヤ。
// useCanvasViewersStore の cursors を購読し、xRatio/yRatio を stage 座標へ変換して描画する。

import { useCanvasViewersStore } from "./store/canvas-viewers-store";
import { CANVAS_HEIGHT_PX, CANVAS_WIDTH_PX } from "../../lib/canvas-coordinates";

const CURSOR_STALE_MS = 30_000;
const CURSOR_LAYER_Z_INDEX = Number.MAX_SAFE_INTEGER - 1;

export function CanvasCursorsLayer(): JSX.Element {
  const viewers = useCanvasViewersStore((s) => s.viewers);
  const cursors = useCanvasViewersStore((s) => s.cursors);
  const now = Date.now();

  return (
    <div
      data-testid="canvas-cursors-layer"
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        // カーソルはキャンバス内の図形より上、キャンバス外の操作パネルより下に表示する。
        zIndex: CURSOR_LAYER_Z_INDEX,
      }}
    >
      {Object.entries(cursors).map(([userId, cursor]) => {
        if (now - cursor.updatedAt > CURSOR_STALE_MS) return null;
        const viewer = viewers[userId];
        if (!viewer) return null;
        const x = cursor.xRatio * CANVAS_WIDTH_PX;
        const y = cursor.yRatio * CANVAS_HEIGHT_PX;
        return (
          <div
            key={userId}
            data-testid={`viewer-cursor-${userId}`}
            style={{
              position: "absolute",
              left: `${x}px`,
              top: `${y}px`,
              transform: "translate(-2px, -2px)",
              pointerEvents: "none",
              willChange: "transform",
            }}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" style={{ display: "block" }}>
              <path
                d="M2,2 L2,16 L6,12 L9,18 L11,17 L8,11 L14,11 Z"
                fill={viewer.color}
                stroke="#ffffff"
                strokeWidth="1"
              />
            </svg>
            <div
              style={{
                marginLeft: "16px",
                marginTop: "-4px",
                background: viewer.color,
                color: "#fff",
                fontSize: "11px",
                padding: "2px 6px",
                borderRadius: "4px",
                whiteSpace: "nowrap",
                boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
              }}
            >
              {viewer.displayName}
            </div>
          </div>
        );
      })}
    </div>
  );
}
